module.exports = __webpack_public_path__ + "img/logo-blw.5ffeb19e.png";